import CentralBackups from './CentralBackups';

export default CentralBackups;
